import { render } from "./vgoouttype.vue?vue&type=template&id=a2ad8256&scoped=true"
import script from "./vgoouttype.vue?vue&type=script&lang=js"
export * from "./vgoouttype.vue?vue&type=script&lang=js"

import "./vgoouttype.vue?vue&type=style&index=0&id=a2ad8256&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ad8256"]])

export default __exports__